export default {
  hidden: 0,
  unnecessary: 4,
  attached_none: 5,
  list: [
    { id: 'documentType0', value: 0, text: '非表示' },
    { id: 'documentType1', value: 1, text: '媒介契約書' },
    { id: 'documentType2', value: 2, text: '委任状' },
    { id: 'documentType3', value: 3, text: '代金納付期限通知書' },
    { id: 'documentType4', value: 4, text: '所有者のため提出不要' },
    { id: 'documentType5', value: 5, text: '添付なし' },
  ],
};
